import { SceneInteriorExterior, SceneDayNight } from '../../../../types/scene.types';

// 获取场号单元格背景颜色
export const getSceneCodeCellBackgroundColor = (
  interiorExterior: SceneInteriorExterior | null | undefined,
  dayNight: SceneDayNight | null | undefined
): string => {
  // 如果内外或日夜都没有值，不应用背景色
  if (!interiorExterior || !dayNight) {
    return 'var(--color-scene-cell-null)';
  }

  // 组合1：内外为"外"或"内外"，日夜为"夜" → var(--color-scene-cell-exterior-night)
  if (
    (interiorExterior === SceneInteriorExterior.EXTERIOR || 
     interiorExterior === SceneInteriorExterior.INTERIOR_EXTERIOR) &&
    dayNight === SceneDayNight.NIGHT
  ) {
    return 'var(--color-scene-cell-exterior-night)';
  }
  
  // 组合2：内外为"外"或"内外"，日夜不为"夜" → var(--color-scene-cell-exterior-day)
  if (
    (interiorExterior === SceneInteriorExterior.EXTERIOR || 
     interiorExterior === SceneInteriorExterior.INTERIOR_EXTERIOR) &&
    dayNight !== SceneDayNight.NIGHT
  ) {
    return 'var(--color-scene-cell-exterior-day)';
  }
  
  // 组合3：内外为"内"，日夜为"夜" → var(--color-scene-cell-interior-night)
  if (
    interiorExterior === SceneInteriorExterior.INTERIOR &&
    dayNight === SceneDayNight.NIGHT
  ) {
    return 'var(--color-scene-cell-interior-night)';
  }
  
  // 组合4：内外为"内"，日夜不为"夜" → var(--color-scene-cell-interior-day)
  if (
    interiorExterior === SceneInteriorExterior.INTERIOR &&
    dayNight !== SceneDayNight.NIGHT
  ) {
    return 'var(--color-scene-cell-interior-day)';
  }
  
  // 默认情况
  return 'transparent';
};



